<template>
    <ul class="school_list">
        <template v-for="item in list">
            <school_list_item :objItem="item"/>
        </template>
    </ul>
</template>

<script>
import school_list_item from "./school_list_item.vue"
    export default {
        components:{
            school_list_item
        },
        props:{
            list: Array
        }
    }
</script>

<style lang="scss" scoped>
.school_list{
    background: #fff;
    display: flex;
    flex-direction: column;
}
</style>
